import { jsx as b, jsxs as x } from "react/jsx-runtime";
import { useMemo as l, useEffect as D } from "react";
const E = ({
  nativeListPrice: c,
  nativeSpotPrice: s,
  skuSpecifications: n,
  unitMultiplier: a,
  hasPromotionalPrice: i,
  defaultScListPrice: P,
  setIsShowProductBadge: d
}) => {
  const { listPrice: u, spotPrice: o } = i || {}, f = (r, e) => l(() => {
    const g = (r - e) * 100 / r;
    return Math.round(g);
  }, [e, r]), { listPriceCustom: m, spotPriceCustom: p } = l(() => u && o && o !== s ? {
    listPriceCustom: u,
    spotPriceCustom: o
  } : {
    listPriceCustom: c,
    spotPriceCustom: s
  }, [
    u,
    o,
    s,
    c
  ]), C = "Venda por unidade", N = n == null ? void 0 : n.some((r) => r.field.originalName === C && r.values.some((e) => e.originalName === "true")), h = P || (N ? m : ((r) => Number(r.toString().match(/^\d+(?:\.\d{0,2})?/)))(m * a)), t = Math.round(
    Number(f(h, p))
  );
  return D(() => {
    if (!t || t <= 0) {
      d(!1);
      return;
    }
    d(!0);
  }, [t]), !t || t <= 0 ? null : /* @__PURE__ */ b("div", { className: "product-card-discount-badge", children: /* @__PURE__ */ x("p", { className: "product-card-discount-badge-value", children: [
    t,
    "%"
  ] }) });
};
export {
  E as ProductCardDiscountBadge
};
